import { darken } from '@mui/material/styles';
import { COLORS } from '../utils/Application_Constants';

export default {
    styleOverrides: {
        root: {
            fontWeight: '500',
            border: `1px solid ${COLORS.LT_MIDNIGHT5}`,
            padding: '.25rem',
            borderRadius: '8px',
            textAlign: 'center',
        },
        label: {
            textTransform: 'uppercase',
        },
        colorWarning: {
            border: `1px solid ${COLORS.GOLD}`,
            backgroundColor: '#FEF7E5',
            color: COLORS.GOLD,
        },
    },
    variants: [
        {
            props: (props) => props.variant === 'lt-admin' || props.variant === 'lt-admin-outlined',
            style: {
                borderRadius: 8,
                padding: '8px 24px',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '100%',
                letterSpacing: '0%',
                '.MuiChip-label': { padding: 0 },
                border: 'none',
                color: COLORS.WHITE,
            },
        },
        {
            props: (props) =>
                (props.variant === 'lt-admin' || props.variant === 'lt-admin-outlined') &&
                props.size === 'small',
            style: {
                padding: '4px 16px',
                fontSize: '13px',
            },
        },
        {
            props: { variant: 'lt-admin-outlined' },
            style: { borderWidth: '1px', borderStyle: 'solid' },
        },
        {
            props: { variant: 'lt-admin', color: 'default' },
            style: { backgroundColor: COLORS.LT_MIDNIGHT75 },
        },
        {
            props: { variant: 'lt-admin', color: 'info' },
            style: { backgroundColor: COLORS.LT_JOURNEY },
        },
        {
            props: { variant: 'lt-admin', color: 'success' },
            style: { backgroundColor: COLORS.LT_EMERALD },
        },
        {
            props: { variant: 'lt-admin', color: 'warning' },
            style: { backgroundColor: COLORS.LT_SUNFLOWER },
        },
        {
            props: { variant: 'lt-admin', color: 'error' },
            style: { backgroundColor: COLORS.LT_PEPPER },
        },
        {
            props: { variant: 'lt-admin-outlined', color: 'default' },
            style: {
                color: COLORS.LT_MIDNIGHT75,
                borderColor: COLORS.LT_MIDNIGHT75,
                backgroundColor: COLORS.LT_MIDNIGHT5,
            },
        },
        {
            props: { variant: 'lt-admin-outlined', color: 'info' },
            style: {
                color: COLORS.LT_JOURNEY,
                borderColor: COLORS.LT_JOURNEY,
                backgroundColor: COLORS.LT_JOURNEY10,
            },
        },
        {
            props: { variant: 'lt-admin-outlined', color: 'success' },
            style: {
                color: COLORS.LT_EMERALD,
                borderColor: COLORS.LT_EMERALD,
                backgroundColor: COLORS.LT_EMERALD10,
            },
        },
        {
            props: { variant: 'lt-admin-outlined', color: 'warning' },
            style: {
                color: COLORS.LT_SUNFLOWER125,
                borderColor: COLORS.LT_SUNFLOWER125,
                backgroundColor: COLORS.LT_SUNFLOWER10,
            },
        },
        {
            props: { variant: 'lt-admin-outlined', color: 'error' },
            style: {
                color: COLORS.LT_PEPPER,
                borderColor: COLORS.LT_PEPPER,
                backgroundColor: COLORS.LT_PEPPER10,
            },
        },
        {
            props: (props) =>
                props.variant === 'lt-admin-pill' || props.variant === 'lt-admin-pill-outlined',
            style: {
                height: 30,
                borderRadius: 20,
                padding: '4px 8px',
                fontSize: '12px',
                fontWeight: '600',
                lineHeight: '100%',
                letterSpacing: '0%',
                '.MuiChip-label': { padding: 0 },
                border: 'none',
            },
        },
        {
            props: (props) =>
                (props.variant === 'lt-admin-pill' || props.variant === 'lt-admin-pill-outlined') &&
                props.color === 'default',
            style: {
                color: COLORS.LT_MIDNIGHT,
                backgroundColor: COLORS.LT_MIDNIGHT10,
                '&.MuiChip-clickable:hover': {
                    backgroundColor: darken(COLORS.LT_MIDNIGHT10, 0.1),
                },
            },
        },
        {
            props: (props) =>
                (props.variant === 'lt-admin-pill' || props.variant === 'lt-admin-pill-outlined') &&
                props.color === 'info',
            style: {
                color: COLORS.LT_FOUNDATION,
                backgroundColor: COLORS.LT_JOURNEY10,
                '&.MuiChip-clickable:hover': {
                    backgroundColor: darken(COLORS.LT_JOURNEY10, 0.1),
                },
            },
        },
        {
            props: (props) =>
                (props.variant === 'lt-admin-pill' || props.variant === 'lt-admin-pill-outlined') &&
                props.color === 'success',
            style: {
                color: COLORS.LT_EMERALD125,
                backgroundColor: COLORS.LT_EMERALD10,
                '&.MuiChip-clickable:hover': {
                    backgroundColor: darken(COLORS.LT_EMERALD10, 0.1),
                },
            },
        },
        {
            props: (props) =>
                (props.variant === 'lt-admin-pill' || props.variant === 'lt-admin-pill-outlined') &&
                props.color === 'warning',
            style: {
                color: COLORS.LT_SUNFLOWER150,
                backgroundColor: COLORS.LT_SUNFLOWER10,
                '&.MuiChip-clickable:hover': {
                    backgroundColor: darken(COLORS.LT_SUNFLOWER10, 0.1),
                },
            },
        },
        {
            props: (props) =>
                (props.variant === 'lt-admin-pill' || props.variant === 'lt-admin-pill-outlined') &&
                props.color === 'error',
            style: {
                color: COLORS.LT_PEPPER125,
                backgroundColor: COLORS.LT_PEPPER10,
                '&.MuiChip-clickable:hover': {
                    backgroundColor: darken(COLORS.LT_PEPPER10, 0.1),
                },
            },
        },
        {
            props: (props) =>
                (props.variant === 'lt-admin-pill' || props.variant === 'lt-admin-pill-outlined') &&
                props.color === 'inReview',
            style: {
                color: COLORS.LT_POMEGRANATE,
                backgroundColor: COLORS.LT_POMEGRANATE10,
                '&.MuiChip-clickable:hover': {
                    backgroundColor: darken(COLORS.LT_POMEGRANATE10, 0.1),
                },
            },
        },
        {
            props: { variant: 'lt-admin-pill-outlined' },
            style: { borderWidth: 1, borderStyle: 'solid' },
        },
        {
            props: { variant: 'lt-admin-pill-outlined', color: 'default' },
            style: { borderColor: COLORS.LT_MIDNIGHT },
        },
        {
            props: { variant: 'lt-admin-pill-outlined', color: 'info' },
            style: { borderColor: COLORS.LT_FOUNDATION },
        },
        {
            props: { variant: 'lt-admin-pill-outlined', color: 'success' },
            style: { borderColor: COLORS.LT_EMERALD125 },
        },
        {
            props: { variant: 'lt-admin-pill-outlined', color: 'warning' },
            style: { borderColor: COLORS.LT_SUNFLOWER150 },
        },
        {
            props: { variant: 'lt-admin-pill-outlined', color: 'error' },
            style: { borderColor: COLORS.LT_PEPPER125 },
        },
    ],
};
